import React, {useEffect, useState} from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {StatementService} from "../../../services";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

const StatementModal = (props) => {

    const [open, setOpen] = useState(false);
    const [list, setList] = useState([]);
    const [selectedStatements, setSelectedStatements] = useState([]);

    useEffect(() => {
        StatementService
            .getForSection(props.sectionId)
            .then((response) => {
                setList(response.data);
            });
        setSelectedStatements(props.data
            .countryStatements
            .filter((s) => s.sectionId === props.sectionId));
    }, [props.data, props.sectionId]);

    const {onStatementAdd, onStatementRemove} = props;

    const handleClose = () => {
        setOpen(false);
    }

    const handleAdd = (statement) => {
        onStatementAdd(statement);
        setOpen(false);
    }

    const removeStatement = (statement) => {
        onStatementRemove(statement);
    }


    return (
        <div>
            <table className="table" style={{width: '100%'}}>
                {selectedStatements.map((s, index) => {
                    return <tr>
                        <td>*</td>
                        <td valign="top">
                            {
                                s.statements.map(m => {
                                    return <div>
                                        <span dangerouslySetInnerHTML={{__html: m}}></span>
                                    </div>
                                })
                            }
                        </td>
                        <td>
                            <IconButton size="small" aria-label="delete" onClick={() => removeStatement(s)}>
                                <DeleteIcon color="error"/>
                            </IconButton>
                        </td>
                    </tr>

                })}
            </table>
            <Button variant="contained" color="secondary" size="small" onClick={() => setOpen(true)}>Add
                Statements</Button>

            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add statement</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please add the statement here.
                    </DialogContentText>

                    {list.length > 0 &&
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Statement</TableCell>
                                        <TableCell>&nbsp;</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        list.map((row) => (
                                            <>
                                                <TableRow key={row.id}>
                                                    <TableCell style={{padding: 10, paddingLeft: 10, margin: 0}}
                                                               component="td"
                                                               scope="row">
                                                        {row.title}

                                                    </TableCell>
                                                    <TableCell style={{padding: 0, margin: 0, paddingLeft: 5}}>
                                                        <Button onClick={() => handleAdd(row)}>Add</Button>
                                                    </TableCell>
                                                </TableRow>
                                            </>))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                    {
                        list.length === 0 &&
                        <>There is no statement set that can be added to this section.</>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default StatementModal;